var _rect, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFeedbackIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 82,
    viewBox: "0 0 73 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 24.7908,
    y: 2.23605,
    width: 48.5769,
    height: 64.2678,
    rx: 6.5,
    transform: "rotate(20 24.7908 2.23605)",
    fill: "white",
    stroke: "#E6570E",
    strokeWidth: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.5525 13.8774C30.8884 15.0916 29.8623 17.9107 33.1982 19.1249C36.5342 20.339 37.5602 17.52 40.8961 18.7341C44.232 19.9483 43.206 22.7674 46.5419 23.9815C49.8778 25.1957 50.9038 22.3766 54.2398 23.5908C57.5757 24.805 56.5496 27.6241 59.8855 28.8382",
    stroke: "#E6570E",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0859 26.1499C26.4218 27.3641 25.3958 30.1832 28.7317 31.3973C32.0676 32.6115 33.0937 29.7924 36.4296 31.0066C39.7655 32.2208 38.7394 35.0398 42.0753 36.254C45.4112 37.4682 46.4373 34.6491 49.7732 35.8633C53.1091 37.0774 52.0831 39.8965 55.419 41.1107",
    stroke: "#E6570E",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.978 58.7837C26.3273 59.6387 25.6432 61.5181 27.9925 62.3732C30.3417 63.2282 31.0257 61.3488 33.375 62.2039C35.7242 63.0589 35.0401 64.9383 37.3894 65.7934C39.7386 66.6484 40.4226 64.769 42.7719 65.6241C45.1211 66.4791 44.4371 68.3585 46.7863 69.2136",
    stroke: "#FFB633",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeedbackIcon);
export default __webpack_public_path__ + "static/media/feedback-icon.9cd90da95256743156aec95a777426c5.svg";
export { ForwardRef as ReactComponent };